import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useReviewsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemReviewInfo */
  const menuItemReviewInfo = {
    id: "reviewInfo",
    title: t("AppModuleNames.SuperAdmin.reviewInfo"),
    url: baseRouteMakerForSuperAdmin(routes.REVIEW_INFO),
  };
  tempMenuGroup.push(menuItemReviewInfo);
  /* menuItemReviewInfo */

  /* menuItemReviewConfig */
  const menuItemReviewConfig = {
    id: "review-config",
    title: t("AppModuleNames.SuperAdmin.reviewConfig"),
    url: baseRouteMakerForSuperAdmin(routes.REVIEW_CONFIG),
  };
  tempMenuGroup.push(menuItemReviewConfig);
  /* menuItemReviewConfig */

  return tempMenuGroup;
};
